import React from 'react';
import { Content } from '~/layouts/Dash/components';


const BasicContent = ({breadcrumb, children}) => {

  const breadcrumbs = [
    {
      label: 'Potencial Poluidor',
      to: '/potencial_poluidor',
      active: false,
    },
    breadcrumb,
  ];
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Potencial Poluidor"
    >
      {children}
    </Content>
  );
}

export default BasicContent;
